import { NgModule } from '@angular/core';

// Composants graphiques utilises

// Module metier utilises

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers

// Services metier
import { ArretSlbService } from './services/arret-slb.service';

// Pipes

// Bridges avec la partie angular

@NgModule({
	imports: [
	],
	providers: [
		ArretSlbService,
	],
	declarations: [
	],
	exports: [
	]
})
export class ArretSlbModule {
	constructor() { }
}